import styled from 'styled-components';
import device from '../../../styles/mediaSizes';

export const StyledHowTestingWorks = styled.div`
  .section-wrapper {
    display: flex;
    gap: 1%;
    justify-content: space-between;
    align-items: center;
    .section-col-1 {
      width: 50%;
      .solo-image {
        border-radius: 9px;
        height: 100%;
        width: 90%;
        object-fit: cover;
        object-position: left;
        height: 600px;
      }
    }
    .section-col-2 {
      width: 50%;
      .section-title-wrapper {
        margin-bottom: 15px;
        .title {
          margin-bottom: 10px;
        }
        .subtitle {
          margin-bottom: 10px;
          color: #0d2f59;
          font-weight: 600;
          font-size: 2em;
        }
        .description {
          margin: 0;
        }
      }
      .accordion {
        width: 100%;
        .accordion-item {
          border: none;
          border-bottom: #dee2e6 1px solid;
          &:last-child {
            border: none;
          }
          .accordion-header {
            .accordion-button {
              display: flex;
              justify-content: space-between;
              gap: 4%;
              margin: 0;
              padding: 18px 12px;
              &::after,
              &.collapsed::after,
              &:not(.collapsed)::after {
                height: 1em;
                width: 1em;
                background-size: contain;
              }
              &.collapsed:after {
              }
              &:after {
                margin: 0;
              }
              &:focus {
                box-shadow: none;
              }
              &:focus:not(.collapsed) {
                box-shadow: none;
              }
              &:not(.collapsed) {
                color: #0777db;
                background-color: transparent;
                box-shadow: none;
              }
            }
          }
          .accordion-body {
            padding: 0;
            padding: 0 30px 30px;
          }
        }
      }
    }

    @media ${device.sm} {
      & {
        display: flex;
        flex-wrap: wrap;
        gap: 1%;
        justify-content: space-between;
        align-items: center;
        .section-col-1 {
          width: 100%;
          margin-bottom: 35px;
          .solo-image {
            border-radius: 9px;
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: left;
            height: 300px;
          }
        }
        .section-col-2 {
          width: 100%;
          .section-title-wrapper {
            margin-bottom: 15px;
            .title {
              margin-bottom: 10px;
            }
            .subtitle {
              margin-bottom: 10px;
              color: #0d2f59;
              font-weight: 600;
              font-size: 16px;
            }
            .description {
              margin: 0;
            }
          }
          .accordion {
            width: 100%;
            .accordion-item {
              border: none;
              border-bottom: #dee2e6 1px solid;
              &:last-child {
                border: none;
              }
              .accordion-header {
                .accordion-button {
                  display: flex;
                  justify-content: space-between;
                  gap: 4%;
                  margin: 0;
                  padding: 18px 12px;
                  &::after,
                  &.collapsed::after,
                  &:not(.collapsed)::after {
                    height: 1em;
                    width: 1em;
                    background-size: contain;
                  }
                  &.collapsed:after {
                  }
                  &:after {
                    margin: 0;
                  }
                  &:focus {
                    box-shadow: none;
                  }
                  &:focus:not(.collapsed) {
                    box-shadow: none;
                  }
                  &:not(.collapsed) {
                    color: #0777db;
                    background-color: transparent;
                  }
                }
              }
              .accordion-body {
                padding: 0;
                padding: 0 30px 30px;
              }
            }
          }
        }
      }
    }
  }
`;
